"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
class Select extends react_1.default.Component {
    render() {
        const { value, label, options, onChange } = this.props;
        return (react_1.default.createElement("div", { className: "znd-select" },
            react_1.default.createElement("div", { className: "znd-select__box" },
                label,
                react_1.default.createElement(Icon_1.default, { className: "znd-select__icon", name: Zupicons_1.default.sort })),
            react_1.default.createElement("div", { className: "znd-select__options-wrapper" },
                react_1.default.createElement("div", { className: "znd-select__options" }, Object.entries(options).map(([key, optionLabel]) => (react_1.default.createElement("div", { key: key, className: "znd-select__options-item", onClick: () => onChange(key) },
                    value === key ? react_1.default.createElement("i", { className: 'znd-select__options-item-icon icon-check ' }) : null,
                    optionLabel)))))));
    }
}
exports.default = Select;
